import { createContext, useContext } from "react";
import type { SmRole } from "@/domain/sm-models";

export interface TenantContextValue {
  tenantId: string;
  tenantName: string;
  tenantSlug: string;
  userName: string;
  userEmail: string;
  userRole: SmRole | null;
  userAvatarUrl: string | null;
  themeMode: "dark" | "light" | "system";
  logout: () => void;
  /** Perfil de negocio del tenant (fast_food, market, fashion, etc.). */
  businessProfile: string;
  /** Feature flags del tenant (integrations_merchant, etc.). */
  productFlags: Record<string, boolean>;
}

const TenantContext = createContext<TenantContextValue | null>(null);

export const TenantProvider = TenantContext.Provider;

export function useTenantContext(): TenantContextValue {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenantContext must be used inside DashboardLayout");
  return {
    ...ctx,
    userAvatarUrl: ctx.userAvatarUrl ?? null,
    themeMode: ctx.themeMode ?? "dark",
  };
}

/** Safe variant — returns null when called outside TenantProvider (e.g. during SSR or in components rendered before context is ready). */
export function useTenantContextSafe(): TenantContextValue | null {
  return useContext(TenantContext);
}
